export const getTypePresets = ({
  type,
  icon,
  variant,
  title,
  message,
  primaryBtnTxt,
  secondaryBtnTxt,
  showKeepEditingButton
}) => {
  const typePresets = {
    confirm: {
      icon,
      variant: variant || 'primary',
      title: title || 'Confirm',
      message,
      primaryBtnTxt: primaryBtnTxt || 'Confirm',
      secondaryBtnTxt: secondaryBtnTxt || 'Cancel',
      showKeepEditingButton: showKeepEditingButton || false
    },
    'unsaved-changes': {
      icon: icon || 'info-circle-filled',
      variant: variant || 'danger',
      title: title || 'Unsaved Changes',
      message:
        message || 'You have unsaved changes. Are you sure you want to leave without saving?',
      primaryBtnTxt: primaryBtnTxt || 'Discard',
      secondaryBtnTxt: secondaryBtnTxt || 'Cancel',
      showKeepEditingButton: showKeepEditingButton !== undefined ? showKeepEditingButton : false
    }
  };

  return typePresets[type] || typePresets.confirm;
};
